import {createProjectModel} from 'crm/utils/project-model'
import {setting, enableSetting, updateSetting} from './service'

const model = createProjectModel({
    projectNamespace: 'autoTaskSetting',
    state: {},
    effects: {
        *setting({payload}, {call}) {
            return yield call(setting, payload)
        },
        *enableSetting({payload}, {call}) {
            return yield call(enableSetting, payload)
        },
        *updateSetting({payload}, {call}) {
            return yield call(updateSetting, payload)
        },
    },
    reducers: {},
})

export default model
